import { render, staticRenderFns } from "./PurchasedTicketsPage.vue?vue&type=template&id=3cb7f550&scoped=true"
import script from "./PurchasedTicketsPage.vue?vue&type=script&lang=js"
export * from "./PurchasedTicketsPage.vue?vue&type=script&lang=js"
import style0 from "./PurchasedTicketsPage.vue?vue&type=style&index=0&id=3cb7f550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7f550",
  null
  
)

export default component.exports